import React from 'react';
import { connect } from 'react-redux';
import { FormSection, getFormValues, change as formChange } from 'redux-form';
import get from 'lodash/get';
import { useTranslation, withTranslation } from 'react-i18next';

import { TextField, RadioField, CheckboxField, Label } from 'src/jbc-front/components/Form';
import ExtensionSelectField from 'src/components/ExtensionSelectField';
import { LabelMapper } from 'jbc-front/components/FormErrors';
import { isMoneyNumber } from 'src/utils/CustomValidators';
import { EMPLOYEE_FORM } from 'src/constants/FormNames';
import styles from './PaymentBankItemSection.scss';

const TransferBankSelect = ({ employeeBankList, clientBanks, currentClientBankId, setFurikomiSaki, index, totalEmployeeBanksLength }) => {
  const { t } = useTranslation();
  return (
    <div className="u-pc-pb20 u-sp-pb15">
      {setFurikomiSaki(employeeBankList, index, totalEmployeeBanksLength)}
      {clientBanks.length === 0 && (
        <div>
          {t('features.Employees.components.PaymentBankItemSection.transfer_source')} :
          {t('features.Employees.components.PaymentBankItemSection.the_bank_information_for_the_client_has_not_been_set_up')}
        </div>
      )}
      {clientBanks.length === 1 && (
        <div>
          {`${t('features.Employees.components.PaymentBankItemSection.transfer_source')} : 
          ${get(clientBanks.find(item => item.value === currentClientBankId), 'label')}`}
        </div>
      )}
      {clientBanks.length > 1 && (
        <ExtensionSelectField
          widthAuto
          name="clientBankId"
          label={t('features.Employees.components.PaymentBankItemSection.transfer_source')}
          options={clientBanks}
          addBlankOption={false}
          placeholder={t('features.Employees.components.PaymentBankItemSection.please_select_transfer_source')}
        />
      )}
    </div>
  );
};

class PaymentBankItemSection extends React.Component {
  setFurikomiSaki = (employeeBankList, index, totalEmployeeBanksLength) => {
    if (employeeBankList.length === 0) {
      return <div>{this.props.t('features.Employees.components.PaymentBankItemSection.bank_account_information_has_not_been_set')}</div>;
    } else if (totalEmployeeBanksLength === 1 && index === 0) {
      // 口座も支給設定も一件しかない場合はプルダウンを表示せずに強制的に適用する
      const targetPaymentBank = this.props.currentPaymentBanks[0];
      if (targetPaymentBank.employeeBankId == null) {
        this.props.dispatch(formChange(EMPLOYEE_FORM, `${targetPaymentBank.paymentFor}PaymentBanks[0].employeeBankId`, employeeBankList[0].value));
      }
      return (
        <div>
          {this.props.t('features.Employees.components.PaymentBankItemSection.transfer_recipient')} : {employeeBankList[0].label}
        </div>
      );
    }
    return (
      <ExtensionSelectField
        widthAuto
        name="employeeBankId"
        label={this.props.t('features.Employees.components.PaymentBankItemSection.transfer_recipient')}
        options={employeeBankList}
        placeholder={this.props.t('features.Employees.components.PaymentBankItemSection.Please_select_transfer_recipient')}
      />
    );
  };
  onChangeChecked = () => {
    const { dispatch, formKey } = this.props;

    if (this.getValueOfField('checked')) {
      ['employeeBankId', 'transferType'].forEach(field => {
        dispatch(formChange(EMPLOYEE_FORM, `${formKey}.${field}`, null));
      });
    }
  };

  onChangeTransferType = event => {
    const { dispatch, changeOtherChecked, index } = this.props;
    if (event.target.value === 'all') {
      changeOtherChecked(dispatch, index);
    }
  };

  getValueOfField = field => {
    const { currentFormValues } = this.props;
    return (currentFormValues || {})[field];
  };

  selectedFixed = () => this.getValueOfField('transferType') === 'fixed';

  checked = () => this.getValueOfField('checked');

  clientBankId = () => parseInt(this.getValueOfField('clientBankId'), 10);

  selectableBankList = () => {
    const { currentPaymentBanks, employeeBankList, index } = this.props;
    const isSelectedByOther = item => currentPaymentBanks.find((paymentBank, idx) => paymentBank.employeeBankId === item.value && idx !== index);
    const selectable = employeeBankList.filter(item => !isSelectedByOther(item));
    return selectable;
  };

  render() {
    // NOTE: Currently, in Thailand, the payment methods are either full bank transfer or full cash only,
    //       but since there may be a future implementation to set a fixed amount, the code will be kept for now.         
    const TRANSFER_TYPES = [
      { value: 'all', label: this.props.t('features.Employees.components.PaymentBankItemSection.total_amount') },
      // { value: 'fixed', label: this.props.t('features.Employees.components.PaymentBankItemSection.fixed_amount') },
      // { value: 'remain',
      //   label: (
      //     <Label
      //       text={this.props.t('features.Employees.components.PaymentBankItemSection.remaining_balance')}
      //       noteWidth={500}
      //       note={this.props.t('features.Employees.components.PaymentBankItemSection.To_use_fixed_amount_please_set_transfer_account_or_cash_as_remaining_balance_Amount_after_calculation_will_all_be_paid_with_method_set_in_remaining_balance_Cannot_set_more_than_2_remaining_balance')}
      //     />
      //   )
      // }
    ];
    const { formKey, clientBanks, label, index, employeeBankList } = this.props;
    return (
      <React.Fragment>
        <FormSection name={formKey}>
          <div>
            <div>
              <CheckboxField name="checked" label={label} normalize={value => !!value} onChange={this.onChangeChecked} />
            </div>
            {this.checked() && (
              <div>
                <RadioField
                  label={this.props.t('features.Employees.components.PaymentBankItemSection.amount')}
                  name="transferType"
                  options={TRANSFER_TYPES}
                  onChange={event => this.onChangeTransferType(event)}
                />
                <div className={this.selectedFixed() ? styles.fixedAmount : styles.amount}>
                  <TextField name="fixedAmount" label="" yen width={50} validate={isMoneyNumber} disabled={!this.selectedFixed()} />
                  <LabelMapper name="fixedAmount" label="固定額は" />
                </div>
                {label !== this.props.t('features.Employees.components.PaymentBankItemSection.cash') && (
                  <TransferBankSelect
                    totalEmployeeBanksLength={employeeBankList.length}
                    employeeBankList={this.selectableBankList()}
                    clientBanks={clientBanks}
                    currentClientBankId={this.clientBankId()}
                    setFurikomiSaki={this.setFurikomiSaki}
                    index={index}
                  />
                )}
              </div>
            )}
          </div>
        </FormSection>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  currentPaymentBanks: get(getFormValues(EMPLOYEE_FORM)(state), ownProps.name),
  currentFormValues: get(getFormValues(EMPLOYEE_FORM)(state), ownProps.name)[ownProps.index]
});

export default withTranslation()(connect(mapStateToProps)(PaymentBankItemSection));
